<template>
    <div>
        <div id="content" class="document-content">
            <div class="large-empty" v-show="selectedDocID == -1">
                <i class="fa fa-info-circle fa-3x"></i>
                <span>Listeden döküman seçerek görüntüleyebilirsiniz</span>
            </div>
            <div class="doc-detail" v-show="selectedDocID != -1">
                <div class="topbar">
                    <span class="head">{{ selectedDoc.baslik }}</span>
                    <div class="detail">
                        <span class="detail">{{
                            selectedDoc.tarih | moment("DD MMMM YYYY")
                        }}</span>
                        <a
                            class="btn link-blue"
                            @click.prevent="printDocument()"
                        >
                            <i class="fa fa fa-print"></i> Yazdır
                        </a>
                    </div>
                </div>
                <div class="doc-page">
                    <div
                        class="doc-page-detail"
                        v-html="selectedDoc.detail"
                        id="printDocument"
                    ></div>
                </div>
            </div>
        </div>
        <div
            id="rightbar"
            v-click-outside="away"
            class="docs"
            :class="docsOpen ? 'opened' : 'closed'"
        >
            <div class="btn-rightbar">
                <a class @click="toggleDocs()">
                    <i class="fa fa-2x fa-bars"></i>
                </a>
            </div>
            <div class="list-header">
                <span>
                    <i class="fa fa-lg fa-folder"></i>
                </span>
                <span>Dökümanlar</span>
            </div>
            <perfect-scrollbar>
                <table>
                    <table v-for="g in docs" :key="g.id">
                        <tr>
                            <th>{{ g.group }}</th>
                        </tr>
                        <tr
                            :class="d.id == selectedDocID ? 'selected' : ''"
                            @click="navigateDoc(d.id)"
                            class="doc"
                            v-for="d in g.docs"
                            :key="d.id"
                        >
                            <td>
                                <i class="fa fa-file-word fa-lg"></i>
                                {{ d.baslik }}
                            </td>
                        </tr>
                    </table>
                    <tr class="empty" v-if="!docs.length">
                        <th colspan="3">
                            <div class="small-empty">
                                <i class="fa fa-info-circle fa-3x"></i>
                                <span>Döküman yüklenmemiş</span>
                            </div>
                        </th>
                    </tr>
                </table>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
export default {
    name: "Documents",
    data() {
        return {
            selectedDocID: -1,
            selectedDoc: {},
            docsOpen: false,
        };
    },
    computed: {
        docs() {
            var result = _.chain(this.$store.getters.getDocuments)
                .groupBy("title")
                .map((value, key) => ({
                    group: key,
                    docs: value,
                }))
                .value();
            return result;
        },
    },
    methods: {
        away: function () {
            if (this.docsOpen) {
                this.docsOpen = false;
            }
        },
        toggleDocs() {
            this.docsOpen = !this.docsOpen;
        },
        navigateDoc(p) {
            this.$router.push({ path: `/documents/${p}` }).catch(() => {
                const path = `/documents/${p}`;
                if (this.$route.path !== path) this.$router.push(path);
            });
        },
        getDoc(i) {
            if (i > -1) {
                let self = this;
                this.$http
                    .get("api/document.php", {
                        params: {
                            id: i,
                        },
                    })
                    .then(function (response) {
                        self.selectedDoc = response.data.data.doc;
                        self.selectedDocID = self.selectedDoc.id;
                        self.docsOpen = false;
                    });
            }
        },
        printDocument() {
            const options = {
                name: "_blank",
                specs: [
                    "height=800",
                    "height=800",
                    "titlebar=yes",
                    "scrollbars=yes",
                ],
                styles: ["https://pediatrim.net/print/document.css"],
            };
            this.$htmlToPaper("printDocument", options);
        },
    },
    created() {
        this.$store.dispatch("fillDocs");
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            var v = to.params.id != undefined ? to.params.id : -1;
            vm.getDoc(v);
            vm.getDocList();
        });
    },
    beforeRouteUpdate(to, from, next) {
        var v = to.params.id != undefined ? to.params.id : -1;
        this.getDoc(v);
        this.getDocList();
        next();
    },
};
</script>

<style lang="scss">
</style>